import * as Yup from 'yup';

export const AddCreditModalSchema = Yup.object().shape({
  amount: Yup.string().required('An amount is required'),
  creditType: Yup.string().required('Select Credit Type'),
  customer: Yup.string().required('Customer Missing!'),
  reason: Yup.string().required('Reason is required'),
  store: Yup.string().required('Studio Missing!')
});
